import ShopDTO from "@/dto/shop/ShopDTO";
import { openUrl } from "@/utils";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { CouponCloseImgUrlMapping, CouponImagUrlMapping, CouponUrlMapping } from "./util";
import CouponSidebar from "./CouponSidebar";

interface CouponProps {
    shop: ShopDTO;
    cacheName: string;
}

enum ShowMode {
    TOP = "TOP",
    SIDE = "SIDE",
}

const Coupon: React.FC<CouponProps> = function (props) {
    const { shop, cacheName } = props;
    const shopType = shop.type;
    const url = CouponUrlMapping[shopType];
    const imgUrl = CouponImagUrlMapping[shopType];

    function getShowTopCouponMode() {
        if (!url || !imgUrl) return undefined;

        const cacheValue = localStorage.getItem(cacheName + shop.id);

        if (cacheValue) {
            if (cacheValue === ShowMode.TOP) {
                return ShowMode.TOP;
            } else if (cacheValue === ShowMode.SIDE) {
                return ShowMode.SIDE;
            }
        }

        return ShowMode.TOP;
    }

    const [showCouponMode, updateShowTopCouponMode] = useState<ShowMode>(getShowTopCouponMode);

    function handleCouponClick() {
        openUrl(CouponUrlMapping[shopType]);
    }

    function handleClose() {
        localStorage.setItem(cacheName + shop.id, ShowMode.SIDE);

        updateShowTopCouponMode(ShowMode.SIDE);
    }

    useEffect(() => {
        updateShowTopCouponMode(getShowTopCouponMode());
    }, [shop.id]);

    if (!url || !imgUrl) return null;

    if (showCouponMode === ShowMode.SIDE) {
        return <CouponSidebar shopType={shopType} />;
    } else if (showCouponMode === ShowMode.TOP) {
        return (
            <div className="tc" style={{ position: "relative", maxHeight: "161px", marginBottom: 5 }}>
                <img
                    src={imgUrl}
                    alt=""
                    style={{ width: "100%" }}
                    onClick={handleCouponClick}
                    className="cursor-pointer"
                />

                <img
                    className="cursor-pointer"
                    src={CouponCloseImgUrlMapping[shopType]}
                    alt=""
                    style={{ position: "absolute", width: "1.3%", right: "1.5%", top: "9px" }}
                    onClick={handleClose}
                />
            </div>
        );
    } else {
        return null;
    }
};

export default observer(Coupon);
